import React, { useRef } from 'react';
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { selectColor } from '../../core';

const ModalBackground = styled.div`
  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
  z-index: 998;
  background: rgba(0, 0, 0, 0.5);
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  &.modalShow {
    animation: fadeIn 0.3s;
  }
  &.modalHidden {
    display: none;
  }
`;

const ModalContainer = styled.div`
  z-index: 999;
  background: ${selectColor('white')};
  width: 300px;
  height: auto;
  border-radius: 4px;
  padding: 16px;
  margin: 16px;
  display: flex;
  flex-direction: column;
`;

const Title = styled.h4`
  white-space: pre-wrap;
  font-size: 1.8rem;
  font-weight: normal;
  padding: 8px 0;
`;

const Message = styled.p`
  white-space: pre-wrap;
  font-size: 1.2rem;
  color: ${selectColor('gray50')};
  padding: 8px 0;
`;

const BtnWrapper = styled.div`
  text-align: right;
  margin-top: 15px;
  button,
  a {
    padding: 8px 18px;
    border-radius: 4px;
  }
`;

const btnStyles = css`
  color: ${selectColor('blue50')};
  &.styledBtn {
    background: ${selectColor('blue50')};
    font-weight: 600;
    color: ${selectColor('white')};
  }
`;

const BtnCancel = styled.button`
  color: ${selectColor('blue50')};
`;

const BtnClose = styled.button`
  ${btnStyles}
`;

const LinkedBtn = styled(Link)`
  ${btnStyles}
  text-decoration: none;
`;

const LinkedAnchor = styled.a`
  ${btnStyles}
  text-decoration: none;
  &.withMargin {
    margin-left: 2px;
  }
`;

function ModalInformation({
  onClickAction,
  onClickCancel,
  onClickOutside,
  ctaLink,
  ctaAnchor,
  urlLink,
  linkTel,
  linkTel2,
  linkTelText,
  linkTelText2,
  linkTelRef,
  linkTelRef2,
  show = true,
  title = '',
  message = '',
  ctaCancel = '',
  ctaOk = ''
}) {
  const showHideModal = show ? 'modalShow' : 'modalHidden';
  const outsideRef = useRef(null);
  const handleOutsideClick = e => {
    if (!outsideRef.current.contains(e.target)) onClickOutside();
  };
  return (
    <>
      <ModalBackground className={showHideModal} onClick={handleOutsideClick}>
        <ModalContainer ref={outsideRef}>
          <Title>{title}</Title>
          <Message>
            {message}
            {linkTelText && <span>{linkTelText}</span>}
            {linkTel && (
              <LinkedAnchor className='withMargin' href={`tel:${linkTelRef}`}>
                {linkTel}
              </LinkedAnchor>
            )}
            {linkTelText2 && <span>{linkTelText2}</span>}
            {linkTel2 && (
              <LinkedAnchor className='withMargin' href={`tel:${linkTelRef2}`}>
                {linkTel2}
              </LinkedAnchor>
            )}
          </Message>
          <BtnWrapper>
            {ctaCancel && <BtnCancel onClick={onClickCancel}>{ctaCancel}</BtnCancel>}
            {ctaOk && (
              <BtnClose className={ctaCancel ? 'styledBtn' : ''} onClick={onClickAction}>
                {ctaOk}
              </BtnClose>
            )}
            {ctaLink && (
              <LinkedBtn className={ctaCancel ? 'styledBtn' : ''} onClick={onClickCancel} to={urlLink}>
                {ctaLink}
              </LinkedBtn>
            )}
            {ctaAnchor && (
              <LinkedAnchor className={ctaCancel ? 'styledBtn' : ''} onClick={onClickCancel} href={urlLink}>
                {ctaAnchor}
              </LinkedAnchor>
            )}
          </BtnWrapper>
        </ModalContainer>
      </ModalBackground>
    </>
  );
}

ModalInformation.propTypes = {
  onClickAction: PropTypes.func.isRequired
};

export { ModalInformation };
